const updates = [
  {
    date: '07-28',
    title: '《鬼灭之刃 柱训练篇》第8话已更新',
    desc: '炭治郎与无一郎的对战训练进入白热化阶段，本集战斗场面经费拉满。',
    tag: '新番更新',
  },
  {
    date: '07-27',
    title: '《我推的孩子 第二季》第5话上线',
    desc: '舞台剧篇持续推进，阿库亚的新计划逐步浮出水面。',
    tag: '新番更新',
  },
  {
    date: '07-26',
    title: '《怪兽8号》最新话战斗燃爆',
    desc: '日比野卡夫卡变身怪兽8号迎战强敌，制作组诚意十足。',
    tag: '热门更新',
  },
  {
    date: '07-25',
    title: '《防风少年》第16话热播中',
    desc: '风铃高中与外校的全面对抗拉开序幕，新角色登场。',
    tag: '新番更新',
  },
  {
    date: '07-24',
    title: '《葬送的芙莉莲》人气持续走高',
    desc: '本作在各大动漫网站评分长期保持9.8以上，被誉为年度必看。',
    tag: '热门推荐',
  },
  {
    date: '07-23',
    title: '夏季番《迷宫饭》全季高清上线',
    desc: '脑洞大开的奇幻美食番全集可看，一集接一集停不下来。',
    tag: '全集上线',
  },
  {
    date: '07-22',
    title: '站内新增多部OVA剧场版资源',
    desc: '《鬼灭之刃 无限列车篇》《咒术回战0》等剧场版高清在线看。',
    tag: '资源更新',
  },
  {
    date: '07-21',
    title: '播放体验全面升级',
    desc: '优化了移动端播放兼容性，手机追番更流畅更省流量。',
    tag: '系统公告',
  },
  {
    date: '07-20',
    title: '《Re:从零开始》第三季情报更新',
    desc: '第三季制作决定！站内前两季高清全集已备好，补番好时机。',
    tag: '动漫资讯',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            最新的动漫在线观看资源更新与站点动态速递
          </p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-6 md:space-y-7">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-4 md:gap-6 pl-10 md:pl-14">
                <div className="absolute left-[11px] md:left-[15px] w-4 h-4 rounded-full border-2 border-primary-400 bg-background-100 mt-1.5"></div>
                <div className="flex-shrink-0 w-16 md:w-20">
                  <div className="text-xs md:text-sm font-semibold text-primary-600 bg-primary-50 rounded-md px-2 py-1 text-center">
                    {item.date}
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}